import React from 'react';
import Snackbar from 'material-ui/Snackbar';
import colors from '@theme/colors';

const defaultBodyStyle = {
  backgroundColor: colors.SECONDARY,
};
const successBodyStyle = {
  backgroundColor: colors.SUCCESS,
};
const errorBodyStyle = {
  backgroundColor: colors.DANGER,
};
const hiddenBodyStyle = {
  display: 'none',
};
const contentStyle = {
  color: colors.WHITE,
};

export const getSnackbarType = (isSuccessfulAction) => {
  if (isSuccessfulAction === true) {
    return 'success';
  }
  if (isSuccessfulAction === false) {
    return 'error';
  }
  return 'hidden';
};

const StyledSnackbar = (props) => {
  let bodyStyle;
  switch (props.type) {
    case 'success':
      bodyStyle = successBodyStyle;
      break;
    case 'error':
      bodyStyle = errorBodyStyle;
      break;
    case 'hidden':
      bodyStyle = hiddenBodyStyle;
      break;
    default:
      bodyStyle = defaultBodyStyle;
      break;
  }
  return (
    <Snackbar
      id="snackbar"
      {...props}
      bodyStyle={bodyStyle}
      contentStyle={contentStyle}
    />
  );
};

export default StyledSnackbar;



// WEBPACK FOOTER //
// ./components/atoms/Snackbar.js